// extracted by mini-css-extract-plugin
export default {"iconButton":"styles-module--icon-button--efdab"};